// extracted by mini-css-extract-plugin
export default {"warningDialog":"textEditorModal_warningDialog__kEEQW","dialogTitle":"textEditorModal_dialogTitle__p3oSg"};